import { CalendarOutlined, DownOutlined, LineOutlined, PlusOutlined, SearchOutlined, TagOutlined } from '@ant-design/icons'
import { ConfigProvider, Pagination, Radio, Select, TreeSelect } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { CampaignStep, IDataFilterGroupList, InfoCampaignTmp, IVConditionFilterCampaim, useCustomerGroupContext } from '..'
import * as selectOptionsApi from '../../../../../api/selectOptions/selectOptionsApi'
import SvgIconWithMask from '../../../../../components/SvgIconWithMask'
import { NO_DATA, URL_NETWORK, URL_TEMPLATE_IMG } from '../../../../../env'
import '../../CampaignSendsNotifications.scss'

import viVN from 'antd/locale/vi_VN'
import '../../../../../components/ExportImgFigma'

import { ColDef } from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { getInfoCampaignCosts, ICampaignCosts } from '../../../../../api/campaign/campaignApi'
import { user_double, viettel, ZNS } from '../../../../../components/ExportImgFigma'
import { NodataTable } from '../../../../../components/NoDataTable'
import useDebounce from '../../../../../hook/useDebounce'
import useLoading from '../../../../../hook/useLoading'
import useToast from '../../../../../hook/useToast'
import { formatNumber } from '../../../../../services/mixin'
import { CustomLoadingOverlayTable, dataPagination, formatDateToDMY, formatDateToDMYGroup, formatPrice, getTitleSelectOption } from '../../../../../until'
import { IPagination } from '../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup'
import { CONDITIONGROUP } from '../../../../Customers/CustomerGroup/Component/AddGroup/Component/PrivateGroup/AG_PrivateAutomatic'
import { ISelectedCustomer } from '../../../../Customers/CustomerGroup/Component/EditGroup/EditGroup'
import '../../CampaignSendsNotifications.scss'
import { filterInfoOperator } from '../Modal/ModalConditionCampaign'
import { channels, SendStrategy, SendTimeType } from './InfoCreate'
import { ITarget } from '../../../../../api/target/targetApi'
import SelectCustomSearch from '../../Component/SelectCustomSearch'
import ItemConditionDisplay from '../../../../Customers/CustomerGroup/Component/ViewGroup/components/ItemConditionDisplay'
import { dataSendEvent } from '../../../../../services/data'


interface props {
  loading?: boolean
  memoizedColumnDefs: ColDef<any, any>[]
  infoCampaign?: InfoCampaignTmp
  sqlTotal?: string
  listMatchedCustomers: any[]
  dataFilterMatchedCustomers: IDataFilterGroupList
  paginationMatchedCustomers: IPagination
  selectedIdCustomer: ISelectedCustomer[]
  infoOperator: IVConditionFilterCampaim
  setDataFilterMatchedCustomers: (value: IDataFilterGroupList) => void
  onPaginationMatchedCustomers: (page: number, pageSize: number) => void
}

const PreView: React.FC<props> = ({
  memoizedColumnDefs, infoCampaign,
  sqlTotal,
  dataFilterMatchedCustomers, paginationMatchedCustomers,
  listMatchedCustomers,
  selectedIdCustomer,
  infoOperator,
  setDataFilterMatchedCustomers, onPaginationMatchedCustomers,
  loading
}) => {

  const pushToast = useToast()
  const pushLoading = useLoading()
  const [isMore, setMore] = useState<boolean>(true)

  const [infoCampaignCosts, setInfoCampaignCosts] = useState<ICampaignCosts>();

  const { step, voucherTitle, sLCategoryCar, sLNationwide, sLTarget } = useCustomerGroupContext()
  const isVoucherCustomerList = !!infoCampaign?.voucherId && !!voucherTitle?.value;


  const dataTarget = useMemo(() => {
    const targetId = infoCampaign?.targetId;
    if (!targetId || !sLTarget) return [];

    const found = sLTarget.find(item => item.id === targetId);
    return found ? [found] : [];
  }, [infoCampaign?.targetId, sLTarget]);

  const dataCondition = useMemo(() => {
    const filtered = filterInfoOperator(infoOperator);
    if (
      filtered.typeCondition !== CONDITIONGROUP.ALL &&
      filtered.conditions.length === 0
    ) {
      return null;
    }
    return filtered;
  }, [infoOperator]);


  const gInfoCampaignCosts = useDebounce(async () => {
    pushLoading(true)

    const customerId = selectedIdCustomer.length
      ? selectedIdCustomer.map((item: ISelectedCustomer) => Number(item.customerId))
      : undefined;
    const groupCustomerId = infoCampaign?.groupCustomerId?.map(item => Number(item.id))

    const channelListTmp = infoCampaign?.channelList?.map(item => ({
      channelId: item.channelId,
      brandId: item.brandId ?? 0,
      notificationTemplateId: item.notificationTemplateId ?? 0,
    }))
    const result = await getInfoCampaignCosts(
      customerId, groupCustomerId, channelListTmp, sqlTotal,
      undefined, infoCampaign?.voucherId
    )
    if (result?.status) {
      setInfoCampaignCosts(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 2000)

  const formatJSXChanelList = () => {
    return (
      <>
        {
          infoCampaign?.channelList?.map((item, i) =>
            <div
              key={i}
              className="custom-page-css w-full flex gap-2">
              <div className="custom-page-css flex flex-1 ">
                <div className="custome-page-css flex items-center gap-1 w-fit">
                  <img
                    src={channels[item.channelId - 1].icon} alt=""
                    onError={(e) => {
                      e.currentTarget.src = ZNS;
                    }}
                  />
                  <span className='custom-page-css text-344054 text-xs font-regular'>{channels[item.channelId - 1].title}</span>
                </div>
              </div>
              <div className="custom-page-css flex flex-3 items-center text-344054 text-sm font-medium">
                {getTitleSelectOption(item.brands, item.brandId ?? 0)}
              </div>
              <div className="custom-page-css flex flex-3 items-center text-344054 text-sm font-medium">
                {getTitleSelectOption(item.templates, item.notificationTemplateId ?? 0)}
              </div>
              <div className="custom-page-css flex flex-3 items-center text-344054 text-sm font-medium">
                {item.categories}
              </div>

            </div>
          )
        }

      </>
    )
  }

  useEffect(() => {
    if (infoCampaign?.channelList?.length) {
      const isCondition = infoCampaign?.channelList?.every((item) => item?.notificationTemplateId !== undefined)
      if (isCondition) {
        gInfoCampaignCosts()
      }
      else {
        setInfoCampaignCosts(undefined)
      }
    } else {
      setInfoCampaignCosts(undefined)
    }
  }, [infoCampaign, selectedIdCustomer])


  return (
    <div className='custom-page-css w-full  flex flex-col gap-4 pt-4'>
      <div className="custom-page-css  w-full flex  gap-3">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Tên chiến dịch thủ công</span>
        <span className="custom-page-css flex-5 font-bold text-base">{infoCampaign?.title}</span>

      </div>
      <div className="custom-page-css  w-full flex  gap-3">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Mô tả</span>
        <span className="custom-page-css flex-5 font-medium text-base">{infoCampaign?.description}</span>

      </div>
      <div className="custom-page-css  w-full flex  gap-3">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Mục tiêu</span>

        <div className="custom-page-css flex-5 font-bold text-base">
          <div className="custome-page-css flex gap-2 w-fit">
            {
              dataTarget.map((item, i) => (
                <Radio.Button
                  key={i}
                  value={infoCampaign?.targetId}
                  className={`custom-page-css flex items-center gap-4 rounded `}
                  // style={{
                  //   border: `1px solid #${item?.colorBorder?.trim()}!important`
                  // }}

                   style={{
                      borderColor: `#${item?.colorBorder.trim()}`,
                      color: `#${item?.colorText.trim()}`,
                      backgroundColor: `#${item?.bgColor.trim()}`, // 1A = 10% opacity
                    }}
                >
                  <SvgIconWithMask
                    src={URL_TEMPLATE_IMG + item?.icon}
                    onError={<TagOutlined />}
                    color={`#${item?.colorText}`}
                    size={18}
                  />
                  <span className=''>{item?.title}</span>
                </Radio.Button>
              ))
            }
          </div>
        </div>

      </div>

      {
        voucherTitle?.value ?
          <div className="custom-page-css  w-full flex  gap-3">
            <span className="custom-page-css flex-2 text-344054 font-medium text-base">Tên chương trình voucher</span>
            <span className="custom-page-css flex-5 font-bold text-base">{voucherTitle?.label ?? NO_DATA}</span>
          </div>
          :
          null
      }
      <div className="custom-page-css  w-full flex  gap-3">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Hình thức</span>
        <div className="custom-page-css flex-5 font-bold text-base">
          {infoCampaign?.type === SendStrategy.PRIORITY_BY_CHANNEL ? 'Ưu tiên gửi theo kênh' : 'Đồng thời gửi nhiều kênh'}
        </div>

      </div>
      <div className="custom-page-css  w-full flex  gap-3">
        <div className="custom-page-css flex gap-2 items-center flex-1 ">
          <img src={user_double} alt="" />
          <span className='custom-page-css text-base font-regular'>Số lượng khách hàng</span>
          <span className='custom-page-css text-base font-regular'>{formatPrice(selectedIdCustomer.length)}</span>
        </div>
        <div className="custom-page-css flex gap-2 items-center flex-1 ">
          <CalendarOutlined />
          <span className='custom-page-css text-base font-regular'>Thời gian gửi:</span>
          <span className='custom-page-css text-base font-regular'>
            {(() => {
              switch (infoCampaign?.role) {
                case SendTimeType.NOW:
                  return 'Tức thì'
                case SendTimeType.SCHEDULED:
                  return `Lên lịch ${formatDateToDMYGroup(infoCampaign?.dateSend)} - ${infoCampaign?.timeSend}`
                case SendTimeType.OPTIONS:
                  return `Gửi trước ${getTitleSelectOption(dataSendEvent, infoCampaign?.sendEvent ?? 0)} ${infoCampaign?.sendInAdvance} ${infoCampaign?.sendBeforeUnit === 'day' ? 'ngày' : 'giờ'} lúc ${infoCampaign?.sendHour}`
                default:
                  return ''
              }
            })()}
          </span>
        </div>

      </div>
      <div className="custom-page-css  w-full flex flex-col  gap-2">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Mẫu nội dung cho kênh gửi</span>
        <div className="custom-page-css w-full flex flex-col gap-3">
          <div className="custom-page-css w-full flex gap-2">
            <div className="custom-page-css flex flex-1 items-center text-344054 text-sm font-regular">
              Kênh gửi
            </div>
            <div className="custom-page-css flex flex-3 items-center text-344054 text-sm font-regular">
              Brandname
            </div>

            <div className="custom-page-css flex flex-3 items-center text-344054 text-sm font-regular">
              Mẫu nội dung
            </div>
            <div className="custom-page-css flex flex-3 items-center text-344054 text-sm font-regular">
              Thương hiệu hãng xe
            </div>


          </div>
          {formatJSXChanelList()}

        </div>

      </div>

      {/* //#region xét điều kiện hay nhóm */}
      {dataCondition ?
        <>
          <div className="custom-page-css flex flex-col gap-2 flex-1">
            <span
              className='custom-page-css text-base font-bold'>
              Điều kiện lọc
              <span className='custom-page-css text-base text-1890FF font-medium'>
                {
                  dataCondition.typeCondition !== CONDITIONGROUP.ALL ?
                    (dataCondition.conditions.length > 0 ?
                      `(${dataCondition.conditions.length} tiêu chí đang áp dụng)` :
                      '') :
                    '(1 tiêu chí đang áp dụng)'
                }
              </span>
            </span>
            {
              dataCondition?.conditions.length > 0 && <>
                <div className="custom-page-css flex gap-2 flex-1">
                  <div className="custom-page-css flex flex-col gap-2 flex-1">
                    <span className='custom-page-css text-base text-344054 font-regular'>Trường</span>

                  </div>
                  <div className="custom-page-css flex flex-col gap-2 flex-1">
                    <span className='custom-page-css text-base text-344054 font-regular'>Điều kiện</span>
                  </div>
                  <div className="custom-page-css flex flex-col gap-2 flex-1">
                    <span className='custom-page-css text-base text-344054 font-regular'>Giá trị</span>
                  </div>
                </div>
                <div className="custom-page-css flex flex-col flex-1">
                  {
                    dataCondition?.conditions?.map((item, i) => (
                      <div
                        key={i}
                        className="custom-page-css flex gap-2 flex-1"
                      >
                        <div className="custom-page-css flex flex-col gap-2 flex-1">
                          <span className='custom-page-css text-base text-344054 font-medium'>
                            {item?.CustomerField?.label}
                          </span>
                        </div>
                        <div className="custom-page-css flex flex-col gap-2 flex-1">
                          <span className='custom-page-css text-base text-344054 font-medium'>
                            {item?.condition?.label}
                          </span>
                        </div>
                        <div className="custom-page-css flex gap-2 flex-1">
                          <ItemConditionDisplay
                            item={item}
                          />
                        </div>
                      </div>
                    ))
                  }
                </div>
              </>
            }
          </div>
        </> :
        <div className="custom-page-css  w-full flex flex-col  gap-3">
          <span className="custom-page-css  text-344054 font-bold text-base">Danh sách nhóm khách hàng ({infoCampaign?.groupCustomerId?.length})</span>
          <div className="custom-page-css flex items-center gap-2">

            {infoCampaign?.groupCustomerId?.map((item, i) => (
              <span
                key={i}
                className='custom-page-css uppercase text-344054 font-regular text-xs bg-F9FAFB p-1 rounded'>
                {item.title} ({formatNumber(item.total ?? 0)})
              </span>
            ))}

          </div>
        </div>
      }
      {/* //#endregion */}

      <div className="custom-page-css  w-full flex flex-col  gap-3">
        <span className="custom-page-css flex-2 text-344054 font-bold text-base">Danh sách khách hàng</span>

        <div className="custom-page-css flex items-start gap-2">
          <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
            <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
              <div className="d-flex align-center w-full">

                <TreeSelect
                  // className={'w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none no-focus-border'}
                  className='custom-page-css bg-FCFCFD-ant-select w-full  border-none no-focus-border overflow-hidden'
                  multiple
                  showSearch
                  placeholder="Chọn đơn vị"
                  allowClear
                  value={dataFilterMatchedCustomers?.listUnit}
                  treeDefaultExpandAll={false}
                  treeData={sLNationwide}
                  filterTreeNode={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, listUnit: e })}
                />
              </div>
            </div>
          </div>

          <div className="custom-page-css h-fit flex-1 d-flex gap-2 overflow-hidden">
            <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center py-2-px justify-between overflow-hidden">
              <div className="d-flex align-center w-full">
                <Select
                  showSearch={false}
                  allowClear
                  mode="multiple"
                  // className="w-full text-left text-span-select  bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                  className='w-full font-regular p-none-select line-none line-none-item inline-none size-selector border-none '
                  popupClassName="position-dropdow custome-select-item h-popUp"
                  variant="borderless"
                  placeholder="Thương hiệu"
                  options={sLCategoryCar}
                  value={dataFilterMatchedCustomers?.listCategoryCar}
                  onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, listCategoryCar: e })}
                />
              </div>
            </div>
          </div>
          <div className='custom-page-css h-36px flex flex-2'>
            <div className="custom-page-css custom-input-search w-full flex items-center justify-between flex-2 border-F2F4F7 bg-FCFCFD rounded-2  pl-3  overflow-hidden">
              <input
                placeholder="Tìm kiếm thông tin khách hàng"
                className=' border-none  custom-page-css w-full border-none'
                value={dataFilterMatchedCustomers.search}
                onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, search: e.target.value })}
              />
              <div className="border-l-F2F4F7 h-full d-flex align-center">
                <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
              </div>
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex flex-col   gap-3">
          <div className="custom-page-css flex items- gap-1">
            <span className='custom-page-css text-base text-344054 font-regular'>{formatNumber(isVoucherCustomerList ? paginationMatchedCustomers.total : selectedIdCustomer.length)} khách hàng</span>
          </div>
        </div>
        <div className="ag-theme-alpine custom-table-ag custom-h-modal" style={{ height: 550, width: '100%' }}>
          <AgGridReact
            className="my-auto-height-grid"
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            columnDefs={memoizedColumnDefs}
            loading={loading}
            loadingOverlayComponent={CustomLoadingOverlayTable}
            // rowData={listMatchedCustomers.filter(customer =>
            //   selectedIdCustomer.map(item => item.customerId).includes(customer.id)
            // )}
            rowData={isVoucherCustomerList
              ? listMatchedCustomers
              : listMatchedCustomers.filter(customer =>
                selectedIdCustomer.map(item => item.customerId).includes(customer.id)
              )}
            rowHeight={55}
            defaultColDef={{
              resizable: true
            }}
            overlayNoRowsTemplate={NodataTable}
          />
        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={paginationMatchedCustomers.current}
              pageSize={paginationMatchedCustomers.pageSize}
              total={isVoucherCustomerList ? paginationMatchedCustomers.total : selectedIdCustomer.length}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(isVoucherCustomerList ? paginationMatchedCustomers.total : selectedIdCustomer.length, paginationMatchedCustomers.pageSize, paginationMatchedCustomers.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationMatchedCustomers}
            />
          </div>
        </ConfigProvider>
      </div>
      {
        step === CampaignStep.PREVIEW &&
        <div className={` custom-page-css  w-full flex flex-col  gap-3`}>
          <span className="custom-page-css  text-344054 font-bold text-base">Dự tính chi phí</span>
          <div className="custom-page-css flex  gap-2">
            <div className="custom-page-css px-2 py-1 bg-E6F7FF rounded w-fit h-fit"
              onClick={() => setMore(!isMore)}
            >
              {
                isMore ?
                  <LineOutlined style={{ color: '#1890FF' }} /> :
                  <PlusOutlined style={{ color: '#1890FF' }} />
              }
            </div>
            <div className="custom-page-css flex flex-1 flex-col gap-2 pt-1">
              {
                infoCampaignCosts?.Email && infoCampaignCosts?.Email?.length > 0 && (
                  <div className={`custom-page-css flex flex-1 flex-col gap-2 ${isMore ? '' : 'd-none'} `}>
                    <div className="custom-page-css flex flex-1 items-center justify-between">
                      <span className='custom-page-css  text-344054 font-medium text-sm'>EMAIL</span>
                      <span className='custom-page-css text-344054 text-sm'>{formatPrice(infoCampaignCosts?.totalEmailExpense)}đ</span>
                    </div>
                    {
                      infoCampaignCosts?.Email.map((item, i) => (
                        <div key={i} className="custom-page-css w-full flex items-center justify-between ">
                          <div className="custom-page-css flex items-center gap-2">
                            <div className="custom-page-css flex items-center justify-center p-2 border rounded border-EAECF0 w-16 h-6">
                              <img
                                src={URL_NETWORK + item.networkImage} alt=""
                                onError={(e) => {
                                  e.currentTarget.src = viettel;
                                }} />
                            </div>
                            <span>{item.networkTitle}</span>
                          </div>
                          <span className='custom-page-css text-667085 text-xs'>{formatPrice(item.expense)}đ</span>
                        </div>
                      ))
                    }

                  </div>
                )
              }
              {
                infoCampaignCosts?.ZNS && infoCampaignCosts?.ZNS?.length > 0 && (
                  <div className={`custom-page-css flex flex-1 flex-col gap-2 ${isMore ? '' : 'd-none'} `}>
                    <div className="custom-page-css flex flex-1 items-center justify-between">
                      <span className='custom-page-css  text-344054 font-medium text-sm'>ZNS</span>
                      <span className='custom-page-css text-344054 text-sm'>{formatPrice(infoCampaignCosts?.totalZNSExpense)}đ</span>
                    </div>
                    {
                      infoCampaignCosts?.ZNS.map((item, i) => (
                        <div key={i} className="custom-page-css w-full flex items-center justify-between ">
                          <div className="custom-page-css flex items-center gap-2">
                            <div className="custom-page-css flex items-center justify-center p-2 border rounded border-EAECF0 w-16 h-6">
                              <img
                                src={URL_NETWORK + item.networkImage} alt=""
                                onError={(e) => {
                                  e.currentTarget.src = viettel;
                                }} />
                            </div>
                            <span>{item.networkTitle}</span>
                          </div>
                          <span className='custom-page-css text-667085 text-xs'>{formatPrice(item.expense)}đ</span>
                        </div>
                      ))
                    }

                  </div>
                )}
              {
                infoCampaignCosts?.SMS.length && (
                  <div className={`custom-page-css flex flex-1 flex-col gap-2 ${isMore ? '' : 'd-none'} `}>
                    <div className="custom-page-css flex flex-1 items-center justify-between">
                      <span className='custom-page-css  text-344054 font-medium text-sm'>SMS</span>
                      <span className='custom-page-css text-344054 text-sm'>{formatPrice(infoCampaignCosts?.totalSMSExpense)}đ</span>
                    </div>
                    {
                      infoCampaignCosts?.SMS.map((item, i) => (
                        <div key={i} className="custom-page-css w-full flex items-center justify-between ">
                          <div className="custom-page-css flex items-center gap-2">
                            <div className="custom-page-css flex items-center justify-center p-2 border rounded border-EAECF0 w-16 h-6">
                              <img
                                src={URL_NETWORK + item.networkImage} alt=""
                                onError={(e) => {
                                  e.currentTarget.src = viettel;
                                }} />
                            </div>
                            <span>{item.networkTitle}</span>
                          </div>
                          <span className='custom-page-css text-667085 text-xs'>{formatPrice(item.expense)}đ</span>
                        </div>
                      ))
                    }

                  </div>
                )
              }

              <div className="custom-page-css flex flex-1 items-center justify-between">
                <span className='custom-page-css  text-344054 font-medium text-sm'>Tạm tính</span>
                <div className="custom-page-css flex items-center gap-3 text-039855 font-bold text-base">
                  <span>{formatPrice(infoCampaignCosts?.totalChannelExpense)}đ</span>
                  <span>~</span>
                  <span>{formatPrice(infoCampaignCosts?.totalChannelExpense)}đ</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default React.memo(PreView)
